// action
import {
    GET_ROLE_MODULE_MAPPING_DETAIL_BY_ROLE,
    GET_ROLE_MODULE_MAPPING_DETAIL_BY_ROLE_FAIL,
    GET_ROLE_MODULE_MAPPING_DETAIL_BY_ROLE_SUCCESS,
    GET_ROLE_MODULE_MAPPING_DETAIL_BY_ROLE_RESET
} from '../action/getRoleModuleMappingDetailByRoleAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_ROLE_MODULE_MAPPING_DETAIL_BY_ROLE:
            return {
                ...state,
                apiState: "loading"
            }
        case GET_ROLE_MODULE_MAPPING_DETAIL_BY_ROLE_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_ROLE_MODULE_MAPPING_DETAIL_BY_ROLE_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data.data.result,
            }
        case GET_ROLE_MODULE_MAPPING_DETAIL_BY_ROLE_RESET:
            return initialState
        default:
            return state
    }
}